import customMessageTemplatesAPI from '../../api/customMessageTemplates';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getTemplates($state) {
    return $state.records;
  },
  getActiveTemplates($state) {
    return $state.records.filter(template => !template.archived);
  },
  getArchivedTemplates($state) {
    return $state.records.filter(template => template.archived);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await customMessageTemplatesAPI.get();
      commit('SET_TEMPLATES', response.data);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, data) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await customMessageTemplatesAPI.create(data);
      commit('ADD_TEMPLATE', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },
  async update({ commit }, { id, ...data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await customMessageTemplatesAPI.update(id, data);
      commit('UPDATE_TEMPLATE', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await customMessageTemplatesAPI.destroy(id);
      commit('UPDATE_TEMPLATE', { id, archived: true });
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
  async restore({ commit }, id) {
    commit('SET_UI_FLAG', { isRestoring: true });
    try {
      const response = await customMessageTemplatesAPI.restore(id);
      commit('UPDATE_TEMPLATE', response.data);
    } finally {
      commit('SET_UI_FLAG', { isRestoring: false });
    }
  },
  async deleteFromMeta({ commit }, id) {
    const response = await customMessageTemplatesAPI.deleteFromMeta(id);
    commit('UPDATE_TEMPLATE', response.data);
    return response.data;
  },
  async syncStatus({ commit }, id) {
    const response = await customMessageTemplatesAPI.syncStatus(id);
    commit('UPDATE_TEMPLATE', response.data);
    return response.data;
  },
  async releaseReview({ commit }, id) {
    const response = await customMessageTemplatesAPI.releaseReview(id);
    commit('UPDATE_TEMPLATE', response.data);
    return response.data;
  },
  async destroyReview({ commit }, id) {
    await customMessageTemplatesAPI.destroyReview(id);
    commit('UPDATE_TEMPLATE', { id, archived: true });
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  SET_TEMPLATES($state, data) {
    $state.records = data;
  },
  ADD_TEMPLATE($state, data) {
    $state.records.push(data);
  },
  UPDATE_TEMPLATE($state, data) {
    const index = $state.records.findIndex(t => t.id === data.id);
    if (index !== -1) {
      $state.records.splice(index, 1, { ...$state.records[index], ...data });
    }
  },
  REMOVE_TEMPLATE($state, id) {
    $state.records = $state.records.filter(t => t.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
